module.exports = __webpack_public_path__ + "static/assets/c6a089bb8f98380b457b573b7ce4a187.png";